// Temporary app theme color rollout shim for WEA-4918.
// Use only for Yellow* -> white/gray mapping during rollout.
// Delete after the figma-theme flag rollout or replace with semantic FPL tokens during FPL migration.
export const themeColor = {
  white100: 'var(--weavy-theme-white100)',
  white64: 'var(--weavy-theme-white64)',
  white40: 'var(--weavy-theme-white40)',
  white16: 'var(--weavy-theme-white16)',
  white100Secondary: 'var(--weavy-theme-white100-secondary)',
  white64_T: 'var(--weavy-theme-white64-transparent)',
  white16_T: 'var(--weavy-theme-white16-transparent)',
  white08_T: 'var(--weavy-theme-white8-transparent)',
};
